import { createContext, ReactNode, useState } from "react";
import type { DialogTriggerProps } from "react-aria-components";
import { DialogTrigger as AriaDialogTrigger } from "react-aria-components";

interface CascadiaDialogTriggerOptions {
  isOpen: boolean;
  setIsOpen(isOpen: boolean): void;
  toggle(): unknown;
}

interface Props extends DialogTriggerProps {
  trigger?: ReactNode | ((options: CascadiaDialogTriggerOptions) => ReactNode);
  children: React.ReactNode;
}

export const DialogTriggerContext = createContext({ toggle: () => {} });

export function DialogTrigger(props: Props) {
  const { trigger, children, ...dialogTriggerProps } = props;

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <DialogTriggerContext.Provider
      value={{ toggle: () => setIsOpen((curr) => !curr) }}
    >
      <AriaDialogTrigger
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        {...dialogTriggerProps}
      >
        {typeof trigger === "function"
          ? trigger({ toggle, isOpen, setIsOpen })
          : trigger}
        {children}
      </AriaDialogTrigger>
    </DialogTriggerContext.Provider>
  );
}
